import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, map, Observable, of, take } from 'rxjs';

import { ProfileCountsApiResponse } from '@digital-platform/unified-wp-home/domain';
import { ProfileTrackService } from '@digital-platform/unified-wp-home/services';
import { UwpWasteProfile } from '@digital-platform/unified-wp-waste-profile/domain';
import { WasteProfileRepositoryFacadeService } from '../waste-profile-repository-facade/waste-profile-repository-facade.service';

export const WasteProfileRepositoryResolver: ResolveFn<void> = (
  route: ActivatedRouteSnapshot
): Observable<void> => {
  const profileTrackService = inject(ProfileTrackService);
  const wasteProfileFacadeService = inject(WasteProfileRepositoryFacadeService);

  if (route.queryParams['status']) {
    wasteProfileFacadeService.setActive(route.queryParams['status']);
  }

  profileTrackService
    .getProfilesCount()
    .pipe(
      map((response: ProfileCountsApiResponse) => {
        if (response.profileCounts) {
          wasteProfileFacadeService.setCounts(response.profileCounts);
        }
      }),
      catchError((error) => {
        console.error('Error fetching profile counts:', error);
        return of(null);
      }),
      take(1)
    )
    .subscribe();

  wasteProfileFacadeService
    .getWasteProfileList()
    .pipe(
      map((response: UwpWasteProfile[]) => {
        wasteProfileFacadeService.setWasteProfileList(response);
      }),
      catchError((error) => {
        console.error('Error loading waste profiles:', error);
        return of();
      }),
      take(1)
    )
    .subscribe();

  return of(undefined); // This makes the requests non-blocking vs. if we return the observable directly
};
